import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.regexp.match.js";

/**
  cdnUri returns a function that accepts a filename and returns a full CDN URI for that file.

  Optionally, you can provide a relative path and/or extension, e.g.:

  [in .env.production]
  CDN_URL=//www.nerdwallet.com/cdn

  [in index.js]
  const iconUri = cdnUri('img/icons', 'svg')
  iconUri('mag') === '//www.nerdwallet.com/cdn/img/icons/mag.svg'
*/
// Helper functions
import urljoin from 'url-join'; // Preserves leading double slashes (urljoin dedupes all slashes).

var protectedUrlJoin = function protectedUrlJoin() {
  for (var _len = arguments.length, joinArgs = new Array(_len), _key = 0; _key < _len; _key++) {
    joinArgs[_key] = arguments[_key];
  }

  return joinArgs[0].slice(0, 2) === '//' ? "/".concat(urljoin.apply(void 0, joinArgs)) : urljoin.apply(void 0, joinArgs);
};

var checkCdnVariable = function checkCdnVariable(pointer) {
  if (!pointer) {
    throw new Error("process.env.CDN_URL is unaccessible. If you've already configured this\n       variable, make sure your application has access to it. If you're running a\n       test, make sure your tests have access to this environment variable.");
  }
};

var warnIfTrailingSlash = function warnIfTrailingSlash(uri, nodeEnv) {
  if (nodeEnv === 'development' && uri.match(/\/$/)) {
    console.error('CDN_URL should not include a trailing slash. Check .env files.');
  }
}; // Exports


export var cdnUri = function cdnUri(relativePath, extension) {
  var path = relativePath || '';
  var ext = extension ? ".".concat(extension) : '';
  return function (filename) {
    var cdnUrl = process.env.CDN_URL;
    checkCdnVariable(cdnUrl);
    warnIfTrailingSlash(cdnUrl, process.env.NODE_ENV);
    return protectedUrlJoin(cdnUrl, path, "".concat(filename).concat(ext));
  };
};
export var iconUri = cdnUri('img/icons', 'svg');
var cdn = {
  cdnUri: cdnUri,
  iconUri: iconUri
};
export default cdn;